import React from "react";
import "./MoreLikeThis.css";
import { Button, Typography, useMediaQuery } from "@mui/material";
import EmailImg from "../../../../Assets/Images/email-verification.webp";
import { useNavigate } from "react-router-dom";
import {
  MoreLikeThisBigButton,
  MoreLikeThisSmallButton,
  MLTLinks,
  MLTLoginButton,
} from "../../../calculatorStyleData";

const MoreLikeThis = () => {
  const isLargeScreen = useMediaQuery(" (max-width:992px) ");
  const isMediumScreen = useMediaQuery(" (max-width:768px) ");
  const isSmallScreen = useMediaQuery(" (max-width:576px) ");

  const navigate = useNavigate();
  return (
    <>
      <div className="more_like_this mt-5">
        <div className="d-flex flex-column flex-sm-row align-items-start  align-items-sm-center gap-2">
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 600,
              lineHeight: "20px",
              letterSpacing: "0.48px",
              paddingRight: "15px",
            }}
          >
            MORE LIKE THIS
          </Typography>
          <div className="d-flex flex-row gap-2">
            <Button
              sx={MLTLinks}
              onClick={() => {
                navigate("/loanpage/carloan");
              }}
            >
              Car Loan
            </Button>
            <Button
              sx={MLTLinks}
              onClick={() => {
                navigate("/loanpage");
              }}
            >
              Loans
            </Button>
          </div>
        </div>
        <div className="more_like_this__buttons mt-4">
          <Button
            onClick={() => {
              navigate(
                "/calculators/financial-insights-and-tools/credit-card-balance-transfer-blog"
              );
            }}
            variant="contained"
            sx={MoreLikeThisBigButton}
            fullWidth
          >
            <div className="button__card gap-4 w-100 py-3 px-2">
              <img
                src="https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/credit-card-1737027764144.webp"
                alt=""
                className="personal_loan_lender"
              />
              <div className="d-flex flex-column justify-content-between w-100">
                <div className="d-flex flex-column justify-content-start align-items-start gap-4">
                  <Typography
                    sx={{
                      fontSize: isSmallScreen
                        ? "24.6973px"
                        : isMediumScreen
                        ? "27.7064px"
                        : isLargeScreen
                        ? "29.4771px"
                        : "35.5597px",
                      lineHeight: isSmallScreen
                        ? "32.1216px"
                        : isMediumScreen
                        ? "34.6331px"
                        : isLargeScreen
                        ? "36.8464px"
                        : "44.4496px",
                      color: "#000",
                      letterSpacing: "0.04px",
                      textTransform: "none",
                      textAlign: "start",
                      fontFamily: "'Archivo',sans-serif",
                    }}
                  >
                    Minemi Credit Card Balance Transfer Calculator
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 16,
                      lineHeight: "20px",
                      letterSpacing: "0.48px",
                      color: "#000",
                      textTransform: "none",
                      fontFamily: "'Archivo',sans-serif",
                      textAlign: "start",
                    }}
                  >
                    Easily manage your credit card debt with our Credit Card
                    Balance Transfer Calculator. Calculate savings, lower
                    interest rates, and plan your repayments effortlessly.
                  </Typography>
                </div>
                <div className="text-end">
                  <Button
                    sx={{
                      width: "10rem",
                      fontSize: 16,
                      lineHeight: "24px",
                      textTransform: "none",
                      fontFamily: "'Archivo',sans-serif",
                    }}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Button>
          <div className="d-flex flex-column flex-md-row gap-3 justify-content-between mt-3">
            <Button
              onClick={() => {
                navigate(
                  "/calculators/financial-insights-and-tools/personal-loan-balance-transfer-blog"
                );
              }}
              variant="contained"
              sx={MoreLikeThisSmallButton}
              fullWidth
            >
              <div className="d-flex justify-content-start gap-4 w-100 py-3 px-2">
                <div className="d-flex flex-column justify-content-between gap-4 w-100">
                  <div className="d-flex flex-column justify-content-start align-items-start gap-4">
                    <Typography
                      sx={{
                        fontSize: isSmallScreen
                          ? "24.6973px"
                          : isMediumScreen
                          ? "27.7064px"
                          : isLargeScreen
                          ? "29.4771px"
                          : "35.5597px",
                        lineHeight: isSmallScreen
                          ? "32.1216px"
                          : isMediumScreen
                          ? "34.6331px"
                          : isLargeScreen
                          ? "36.8464px"
                          : "44.4496px",
                        color: "#000",
                        letterSpacing: "0.04px",
                        textTransform: "none",
                        textAlign: "start",
                        fontFamily: "'Archivo',sans-serif",
                      }}
                    >
                      Personal Loan Balance Transfer with MinEMI: Save More on
                      Your Loan{" "}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      sx={{
                        fontSize: 16,
                        lineHeight: "24px",
                        letterSpacing: "0.08px",
                        textAlign: "start",
                        color: "#000",
                        fontFamily: "'Archivo',sans-serif",
                        textTransform: "none",
                      }}
                    >
                      How transferring your loan can help reduce interest rates,
                      lower EMIs, and maximize savings. It simplifies the
                      process, enabling you to save more while managing your
                      finances better.
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="text-end w-100 mb-2">
                <Button
                  sx={{
                    width: "10rem",
                    fontSize: 16,
                    lineHeight: "24px",
                    textTransform: "none",
                    fontFamily: "'Archivo',sans-serif",
                  }}
                >
                  Read More
                </Button>
              </div>
            </Button>
            <Button
              onClick={() => {
                navigate(
                  "/calculators/financial-insights-and-tools/home-loan-balance-transfer-blog"
                );
              }}
              variant="contained"
              sx={MoreLikeThisSmallButton}
              fullWidth
            >
              <div className="d-flex justify-content-start gap-4 w-100 py-3 px-2">
                <div className="d-flex flex-column justify-content-between gap-4 w-100">
                  <div className="d-flex flex-column justify-content-start align-items-start gap-4">
                    <Typography
                      sx={{
                        fontSize: isSmallScreen
                          ? "24.6973px"
                          : isMediumScreen
                          ? "27.7064px"
                          : isLargeScreen
                          ? "29.4771px"
                          : "35.5597px",
                        lineHeight: isSmallScreen
                          ? "32.1216px"
                          : isMediumScreen
                          ? "34.6331px"
                          : isLargeScreen
                          ? "36.8464px"
                          : "44.4496px",
                        color: "#000",
                        letterSpacing: "0.04px",
                        textTransform: "none",
                        textAlign: "start",
                        fontFamily: "'Archivo',sans-serif",
                      }}
                    >
                      Home Loan Balance Transfer with MinEMI: Save More on Your
                      Mortgage
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      sx={{
                        fontSize: 16,
                        lineHeight: "24px",
                        letterSpacing: "0.08px",
                        textAlign: "start",
                        color: "#000",
                        fontFamily: "'Archivo',sans-serif",
                        textTransform: "none",
                      }}
                    >
                      Lower your financial burden with a Home Loan Balance
                      Transfer! Enjoy reduced EMIs, better interest rates, and
                      flexible repayment options. Make the smart move to save
                      more today!
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="text-end w-100 mb-2">
                <Button
                  sx={{
                    width: "10rem",
                    fontSize: 16,
                    lineHeight: "24px",
                    textTransform: "none",
                    fontFamily: "'Archivo',sans-serif",
                  }}
                >
                  Read More
                </Button>
              </div>
            </Button>
          </div>
        </div>
        <div className="mt-4 d-flex justify-content-center">
          <div
            style={{
              width: isSmallScreen ? "90%" : "542px",
              height: isSmallScreen ? "auto" : "348px",
              border: "1px solid gray",
              borderRadius: "4px",
              backgroundColor: "#f4ecf9",
            }}
            className="d-flex flex-column align-items-center gap-3 p-3 "
          >
            <img
              src={EmailImg}
              alt=""
              style={{
                width: "7rem",
                height: "7rem",
                borderRadius: "50%",
              }}
            />
            <div className="px-3 text-center">
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 600,
                  lineHeight: "24px",
                  textAlign: "center",
                  color: "#000",
                  letterSpacing: "0.08px",
                  fontFamily: "'Archivo',sans-serif",
                }}
              >
                Master your finances – right in your inbox!{" "}
              </Typography>
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 500,
                  lineHeight: "24px",
                  textAlign: "center",
                  color: "#000",
                  letterSpacing: "0.08px",
                  fontFamily: "'Archivo',sans-serif",
                }}
                className="mt-2"
              >
                Sign up for MinEMI updates to get money-saving tips, practical
                advice, and helpful tools. We’ll help you spend wisely, save
                more, and achieve your financial goals with ease.
              </Typography>
              <Button
                sx={MLTLoginButton}
                className="mt-3"
                onClick={() => {
                  navigate("/login");
                }}
              >
                Sign Up
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MoreLikeThis;
